import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import moment from 'moment';
import GlobalFilterPanel from '../../filter/GlobalFilterPanel';
import LanguageStringResolver from '../../fields/language/LanguageStringResolver';
import DataMiningCommonFilterPanel from '../DataMiningCommonFilterPanel';
import Logger, { LOG_LEVELS } from '../../../utils/log';
import { TransactionReportTypeEnum } from '../../../utils/enums';

const log = new Logger('DATA_MINING_GL_STATUS_GL_SIDE_FILTER_PANEL', LOG_LEVELS.DEBUG);

// Repeated code from GlobalFilterPanel which gets undefined in a test due to mocking
// TODO: fix up later. Taking the hit while we're sorting test coverage
const FILTER_PERIOD_GROUP = { DATE_RANGE: 'DATE_RANGE' };
const GlobalFilterPanelFields = { PARAM_COMPANY_ID: 'companyId' };

const DEFAULT_FILTER_SETTING = {
    hideElements: {
        month: true,
        year: true,
        countryCode: true,
        returnType: true,
        returnStatus: true
    },
    fieldOptions: {},
    filterPeriodGroup: FILTER_PERIOD_GROUP.DATE_RANGE,
    adaptPeriodOptions: {
        customDateRangeProvider: (selection) => {
            let customDateRange = {};
            let selectionEndDate = selection.endDate ? moment.utc(selection.endDate) : moment.utc(new Date());
            customDateRange.endDate = selectionEndDate;
            customDateRange.startDate = moment.utc(selectionEndDate).subtract('1', 'month');
            return customDateRange;
        }
    }
};
DEFAULT_FILTER_SETTING.fieldOptions[GlobalFilterPanelFields.PARAM_COMPANY_ID] = {
    useCompanyCode: true
};

export class GLStatusGLSideFilterPanel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selection: {
                reportType: TransactionReportTypeEnum.GLSTATUSGLSIDE.value,
                startDate: '',
                endDate: '',
                companyCode: '',
                includeChildCompanies: false,
                overviewType: 1
            },
            filterSetting: DEFAULT_FILTER_SETTING
        };
        this.onReportChangeHandler = this.onReportChangeHandler.bind(this);
        this.onCheckboxChangeHandler = this.onCheckboxChangeHandler.bind(this);
        this.onSearchClickHandler = this.onSearchClickHandler.bind(this);
    }

    onReportChangeHandler(selection = {}) {
        log.debug('onReportChangeHandler reportType', selection.reportType);
        this.props.onReportTypeChange(selection);
    }

    onCheckboxChangeHandler(evt) {
        let selection = Object.assign({}, this.state.selection);
        selection.includeChildCompanies = evt.target.checked;
        this.setState({
            selection: selection
        });
    }

    onSearchClickHandler(selection) {
        log.debug('onSearchClickHandler(): state.selection: ', this.state.selection);
        log.debug('onSearchClickHandler(): selection: ', selection);
        let existingSelection = Object.assign({}, this.state.selection);
        existingSelection.startDate = selection.startDate;
        existingSelection.endDate = selection.endDate;
        existingSelection.companyCode = selection.companyCode;
        this.props.onSearchClick(existingSelection);
    }

    render() {
        log.debug('render() - props: ', this.props);
        let selection = this.state.selection || {};
        const filterSetting = this.state.filterSetting || DEFAULT_FILTER_SETTING;

        return (
            <div data-test="component-gl-status-gl-side-filter-panel">
                <s-box name="filter-panel">
                    <GlobalFilterPanel
                        {...filterSetting}
                        onSearchClick={this.onSearchClickHandler}>
                        <DataMiningCommonFilterPanel
                            reportType={this.state.selection.reportType}
                            onReportTypeChange={this.onReportChangeHandler}
                        />
                        <fieldset>
                            <legend><LanguageStringResolver string='dataMining_GLStatusOverviewIncludeChildCompanies' /></legend>
                            <span className="clear"></span>
                            <input
                                data-test="input-include-child-companies"
                                type="checkbox"
                                onChange={this.onCheckboxChangeHandler}
                                name="glStatusGlSideFilterPanel-incl-child-companies"
                                checked={selection.includeChildCompanies}
                            />
                            <label className="checkbox">True</label>
                        </fieldset>
                    </GlobalFilterPanel>
                    <div className="clear"></div>
                </s-box>
            </div>
        );
    }
}


GLStatusGLSideFilterPanel.defaultProps = {
    onReportTypeChange: () => { },
    onSearchClick: () => { }
}

function mapStateToProps(state) {
    return {
        languages: state.languages
    }
}

function mapDispatchersToProps(dispatch) {
    const dispatchProps = {};
    return dispatchProps;
}

// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps, mapDispatchersToProps)(GLStatusGLSideFilterPanel);